import Navbar from '../Navbar'
import { useEffect, useState } from 'react';
import { Get_Single_Purchased, Get_Subject_ID } from '../../api/api';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import Loading from '../Loading';
import ItemsTypeSingle from '../loops/itemsTypeSingle';


export default function TypeSinglePurchased() {


  const [loading, setLoading] = useState(true)
  const [response, setResponse] = useState({})

  const [detailLinks, setDetailLinks] = useState([])

  const params = useParams()


  useEffect(() => {
    const getContent = async () => {
      try {
        // const res = await axios.get(Get_Subject_ID + params.contentId)
        const res = await axios.get(Get_Single_Purchased(params.contentId))
        setResponse(res.data)

        const linkIdsParams = params.linkId.split('-')
        const filterLinks = res.data?.subjectBranch?.filter(f => linkIdsParams.includes((f.id).toString()))
        setDetailLinks(filterLinks)

      } finally {
        setLoading(false)
      }
    }
    getContent()



  }, []);


  return (
    <>
      {loading ? <Loading /> : (
        <>
          <Navbar search={false} nav={false} breadcrumb={false} />

          <div className='contentHolder'>
            <ItemsTypeSingle data={response} notSingle={true} detailLinks={detailLinks} />
          </div>

        </>
      )}
    </>
  )
}
